import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { fetchGlobalPage, findSection } from "../services/contentApi";

const GlobalLayoutContext = createContext(null);

export function GlobalLayoutProvider({ children }) {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    fetchGlobalPage()
      .then((data) => {
        if (!cancelled) setPage(data);
      })
      .catch((err) => {
        console.error("Error fetching global layout:", err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const footer = useMemo(() => findSection(page, "footer"), [page]);

  const value = useMemo(
    () => ({ footer, loading }),
    [footer, loading]
  );

  return (
    <GlobalLayoutContext.Provider value={value}>
      {children}
    </GlobalLayoutContext.Provider>
  );
}

export function useGlobalLayout() {
  const ctx = useContext(GlobalLayoutContext);
  if (!ctx) {
    throw new Error("useGlobalLayout must be used within GlobalLayoutProvider");
  }
  return ctx;
}

export function useFooterSection() {
  const { footer, loading } = useGlobalLayout();
  return { section: footer, loading };
}
